import React, {useReducer} from 'react';
import {CompanyConfigContext, CompanyConfigDispatchContext} from './contexts';
import type {CompanyState, CompanyActions} from './types';

interface CompanyConfigProviderProps {
  children: React.ReactElement;
}

function reducer(state: CompanyState, action: CompanyActions): CompanyState {
  switch (action.type) {
    case 'SET_ACTIVE_VIEW':
      return {
        ...state,
        activeView: action.payload.view,
        selectedCompany: action.payload.company ?? null,
      };
    case 'SET_SELECTED_COMPANY':
      return {
        ...state,
        selectedCompany: action.payload,
      };
    default:
      return state;
  }
}

const initialState: CompanyState = {
  activeView: 'list',
  selectedCompany: null,
};

const CompanyConfigProvider = ({children}: CompanyConfigProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <CompanyConfigContext.Provider value={state}>
      <CompanyConfigDispatchContext.Provider value={dispatch}>
        {children}
      </CompanyConfigDispatchContext.Provider>
    </CompanyConfigContext.Provider>
  );
};

export default CompanyConfigProvider;
